import { useQuery } from '@tanstack/react-query';
import { api } from 'src/services';
import { PatientDocument } from 'src/models';
import { UseQueryOverrideOptions } from '../common';

export interface UseGetServiceRequestDocumentListParams {
  serviceRequestId: string;
  includePresignedUrl?: boolean;
}

export type GetServiceRequestDocumentListResponse = {
  documents: PatientDocument[];
};

export const useGetServiceRequestDocumentList = (
  params: UseGetServiceRequestDocumentListParams,
  options?: UseQueryOverrideOptions<GetServiceRequestDocumentListResponse>
) => {
  const { serviceRequestId, includePresignedUrl = false } = params;
  return useQuery({
    ...options,
    queryKey: ['serviceRequestDocumentList', params],
    queryFn: () => {
      return api
        .get<GetServiceRequestDocumentListResponse>(
          `/v3/service_request/${serviceRequestId}/documents`,
          {
            params: {
              include_presigned_url: includePresignedUrl,
            },
          }
        )
        .then(({ data }) => data);
    },
  });
};
